<template>
  <v-dialog v-model="dialog" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">Permissions</v-card-title>
      <v-card-text>Your permissions has changed!</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="close()">Agree</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PermissionChangedModal",
  props: {},
  data: () => ({
    dialog: false,
  }),
  methods: {
    show() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$router.go();
    },
  },
};
</script>

<style scoped>
</style>